module.exports = __webpack_public_path__ + "Flag-666.2ffe9832a7428f6ee0b4620404cfde8a.svg";